import { FormattedMessage } from "react-intl";
import AppointmentRecentSales from "./AppointmentRecentSales";
import { Link } from "react-router-dom";

const RecentSales = ({ sales }: any) => {
  console.log(sales);

  return (
    <div className="flex flex-col gap-4">
      {sales?.map((e: any, i: any) => {
        return <AppointmentRecentSales key={i} i={i} data={e} />;
      })}

      <Link
        to="/sales"
        className="text-color-gray flex items-center gap-1 font-normal cursor-pointer text-xs"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.0611 3.49414C5.0611 3.25252 5.25698 3.05664 5.4986 3.05664L10.5061 3.05664C10.6221 3.05664 10.7334 3.10273 10.8155 3.18478C10.8975 3.26683 10.9436 3.37811 10.9436 3.49414L10.9436 8.50164C10.9436 8.74326 10.7477 8.93913 10.5061 8.93914C10.2645 8.93914 10.0686 8.74326 10.0686 8.50164L10.0686 3.93164L5.4986 3.93164C5.25698 3.93164 5.0611 3.73577 5.0611 3.49414Z"
            fill="#9999A7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.18436 10.8155C3.0135 10.6446 3.0135 10.3676 3.18436 10.1967L10.1264 3.25472C10.2972 3.08387 10.5742 3.08387 10.7451 3.25472C10.916 3.42558 10.916 3.70259 10.7451 3.87344L3.80308 10.8155C3.63222 10.9863 3.35521 10.9863 3.18436 10.8155Z"
            fill="#9999A7"
          />
        </svg>
        <FormattedMessage id="see_more" />
      </Link>
    </div>
  );
};

export default RecentSales;
